var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPaginationRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.52612 14.0291C5.85388 14.0291 5.30892 14.5741 5.30892 15.2463C5.30892 15.9185 5.85388 16.4635 6.52612 16.4635V14.0291ZM23.5329 15.2463L24.3936 16.107C24.8689 15.6316 24.8689 14.861 24.3936 14.3856L23.5329 15.2463ZM15.8902 5.88223C15.4148 5.40689 14.6442 5.40689 14.1688 5.88223C13.6935 6.35758 13.6935 7.12826 14.1688 7.60361L15.8902 5.88223ZM14.1688 22.889C13.6935 23.3643 13.6935 24.135 14.1688 24.6104C14.6442 25.0857 15.4148 25.0857 15.8902 24.6104L14.1688 22.889ZM6.52612 16.4635H23.5329V14.0291H6.52612V16.4635ZM14.1688 7.60361L22.6722 16.107L24.3936 14.3856L15.8902 5.88223L14.1688 7.60361ZM22.6722 14.3856L14.1688 22.889L15.8902 24.6104L24.3936 16.107L22.6722 14.3856Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPaginationRight);
export default __webpack_public_path__ + "static/media/arrow-pagination-right.34bb80bd036838ee420124c240808607.svg";
export { ForwardRef as ReactComponent };